import { useState, type ReactNode } from "react";

type SmartImgProps = {
  src: string;
  alt: string;
  className?: string;
  imgClassName?: string;
  /** o que mostrar enquanto a imagem não existe em public/escape21 */
  placeholder: ReactNode;
};

/**
 * imagem com fallback: renderiza o placeholder por trás e, se o arquivo
 * existir, a imagem cobre ele; se não existir (404), fica só o placeholder.
 */
const SmartImg = ({ src, alt, className = "", imgClassName = "", placeholder }: SmartImgProps) => {
  const [failed, setFailed] = useState(false);

  return (
    <div className={`relative overflow-hidden ${className}`}>
      {placeholder}
      {!failed && (
        <img
          src={src}
          alt={alt}
          loading="lazy"
          onError={() => setFailed(true)}
          className={`absolute inset-0 h-full w-full object-cover ${imgClassName}`}
        />
      )}
    </div>
  );
};

export default SmartImg;
